import React from 'react';

import { colors, fonts, container, sectionHeading, line } from '../theme';
import { deals } from '../data';

function DealCard({ deal }) {
  return (
    <div
      className="lyfe-card lyfe-reveal"
      style={{ border: line.soft, borderRadius: 18, overflow: 'hidden', background: colors.bg }}>
      <div style={{ height: 200, overflow: 'hidden', position: 'relative' }}>
        <img src={deal.img} alt={deal.alt} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        <span
          style={{
            position: 'absolute',
            top: 14,
            left: 14,
            fontSize: 11,
            letterSpacing: '.12em',
            textTransform: 'uppercase',
            background: 'rgba(10,10,12,.7)',
            backdropFilter: 'blur(6px)',
            border: '1px solid rgba(255,255,255,.14)',
            padding: '6px 12px',
            borderRadius: 999,
          }}>
          {deal.tag}
        </span>
      </div>
      <div style={{ padding: 24 }}>
        <div style={{ fontFamily: fonts.serif, fontSize: 15, color: colors.muted2 }}>{deal.place}</div>
        <div style={{ fontSize: 26, fontWeight: 600, marginTop: 6 }}>{deal.title}</div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 14,
            marginTop: 22,
            flexWrap: 'wrap',
          }}>
          <span style={{ color: colors.muted3, fontSize: 14 }}>{deal.when}</span>
          <a
            className="lyfe-btn"
            href="#get"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 7,
              background: colors.ink,
              color: colors.bg,
              fontWeight: 600,
              fontSize: 13,
              padding: '10px 18px',
              borderRadius: 999,
              textDecoration: 'none',
              whiteSpace: 'nowrap',
            }}>
            Unlock in app →
          </a>
        </div>
      </div>
    </div>
  );
}

export default function TonightDeals() {
  return (
    <section id="tonight" style={{ background: colors.bgAlt, borderTop: line.faint }}>
      <div className="lyfe-wrap lyfe-sec" style={{ ...container, padding: '120px 40px' }}>
        <div
          className="lyfe-reveal"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            flexWrap: 'wrap',
            gap: 24,
            marginBottom: 56,
          }}>
          <div>
            <div
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 10,
                fontSize: 12,
                letterSpacing: '.18em',
                textTransform: 'uppercase',
                color: colors.orange,
                fontWeight: 600,
                marginBottom: 20,
              }}>
              <span style={{ position: 'relative', width: 8, height: 8 }}>
                <span style={{ position: 'absolute', inset: 0, borderRadius: '50%', background: colors.orange }} />
                <span
                  style={{
                    position: 'absolute',
                    inset: 0,
                    borderRadius: '50%',
                    background: colors.orange,
                    animation: 'lyfePulse 2s infinite',
                  }}
                />
              </span>
              47 live deals across Miami
            </div>
            <h2 className="lyfe-h2" style={sectionHeading}>Tonight's best</h2>
          </div>
          <a
            className="lyfe-link"
            href="#get"
            style={{
              fontSize: 15,
              color: colors.muted,
              textDecoration: 'none',
              borderBottom: '1px solid rgba(255,255,255,.2)',
              paddingBottom: 4,
            }}>
            See all 47 deals →
          </a>
        </div>

        <div className="lyfe-g3" style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 24 }}>
          {deals.map((deal) => (
            <DealCard key={deal.place} deal={deal} />
          ))}
        </div>
      </div>
    </section>
  );
}
